






import { BaseSelect, selectName } from '#components/baseSelect';

import { NAME } from '../constants';

type Data = {
	TYMPRAC_ID: number,
	TEXT: string,
};

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'TYMPRAC_ID' },
		showLabel: { type: Boolean, default: true },
	},
	data() {
		return {
			storeObject: NAME,
			emptyObject: {
				value: null,
				text: null,
			},
		};
	},
	methods: {
		dbToBaseMapper(data: Data) {
			return {
				value: data.TYMPRAC_ID,
				text: data.TEXT,
			};
		},
	},
});
